export const SHIFT_LIST_PAGE_SIZE = 20;
